<template>
  <div style="background-color: #edf4fc;padding: 0.2rem;">
    <div class="content-title">
      <span style="font-size: 26px;line-height: 50px;font-weight: 700;">考研专业目录大全（学术学位+专业学位）</span>
    </div>
    <div>
      <p class="science-press-p">研究生学位分为学术学位和专业学位，学术学位偏科学研究，专业学位偏实际应用，以下是学科目录具体名单，包含学术学位和专业学位，供大家参考。</p>
      <p class="science-press-p">说明：学术学位中的二级学科也就是我们通常说的研究生专业，当然也有些学校研究生是按一级学科招生。</p>
    </div>
    <el-row style="border: 1px solid #000;">
      <el-col :span="12" style="border-top: 0px;">学科专业代码</el-col><el-col :span="12" style="border-top: 0px;">学科专业名称</el-col>
      <el-col :span="12" style="font-weight: 700;">01</el-col>
      <el-col :span="12" style="font-weight: 700;">哲学</el-col>
      <el-col :span="12">0101</el-col><el-col :span="12">哲学</el-col>
      <el-col :span="12">010101</el-col><el-col :span="12">马克思主义哲学</el-col>
      <el-col :span="12">010102</el-col><el-col :span="12">中国哲学</el-col>
      <el-col :span="12">010103</el-col><el-col :span="12">外国哲学</el-col>
      <el-col :span="12">010104</el-col><el-col :span="12">逻辑学</el-col>
      <el-col :span="12">010105</el-col><el-col :span="12">伦理学</el-col>
      <el-col :span="12">010106</el-col><el-col :span="12">美学</el-col>
      <el-col :span="12">010107</el-col><el-col :span="12">宗教学</el-col>
      <el-col :span="12">010108</el-col><el-col :span="12">科学技术哲学</el-col>
      <el-col :span="12">0151</el-col><el-col :span="12">应用伦理</el-col>
      <el-col :span="12" style="font-weight: 700;">02</el-col>
      <el-col :span="12" style="font-weight: 700;">经济学</el-col>
      <el-col :span="12">0201</el-col><el-col :span="12">理论经济学</el-col>
      <el-col :span="12">020101</el-col><el-col :span="12">政治经济学</el-col>
      <el-col :span="12">020102</el-col><el-col :span="12">经济思想史</el-col>
      <el-col :span="12">020103</el-col><el-col :span="12">经济史</el-col>
      <el-col :span="12">020104</el-col><el-col :span="12">西方经济学</el-col>
      <el-col :span="12">020105</el-col><el-col :span="12">世界经济</el-col>
      <el-col :span="12">020106</el-col><el-col :span="12">人口、资源与环境经济学</el-col>
      <el-col :span="12">0202</el-col><el-col :span="12">应用经济学</el-col>
      <el-col :span="12">020201</el-col><el-col :span="12">国民经济学</el-col>
      <el-col :span="12">020202</el-col><el-col :span="12">区域经济学</el-col>
      <el-col :span="12">020203</el-col><el-col :span="12">财政学</el-col>
      <el-col :span="12">020204</el-col><el-col :span="12">金融学</el-col>
      <el-col :span="12">020205</el-col><el-col :span="12">产业经济学</el-col>
      <el-col :span="12">020206</el-col><el-col :span="12">国际贸易学</el-col>
      <el-col :span="12">020207</el-col><el-col :span="12">劳动经济学</el-col>
      <el-col :span="12">020208</el-col><el-col :span="12">统计学</el-col>
      <el-col :span="12">020209</el-col><el-col :span="12">数量经济学</el-col>
      <el-col :span="12">020210</el-col><el-col :span="12">国防经济</el-col>
      <el-col :span="12">0270</el-col><el-col :span="12">统计学</el-col>
      <el-col :span="12">0271</el-col><el-col :span="12">区域国别学</el-col>
      <el-col :span="12">0251</el-col><el-col :span="12">金融</el-col>
      <el-col :span="12">0252</el-col><el-col :span="12">应用统计</el-col>
      <el-col :span="12">0253</el-col><el-col :span="12">税务</el-col>
      <el-col :span="12">0254</el-col><el-col :span="12">国际商务</el-col>
      <el-col :span="12">0255</el-col><el-col :span="12">保险</el-col>
      <el-col :span="12">0256</el-col><el-col :span="12">资产评估</el-col>
      <el-col :span="12">0258</el-col><el-col :span="12">数字经济</el-col>
      <el-col :span="12" style="font-weight: 700;">03</el-col>
      <el-col :span="12" style="font-weight: 700;">法学</el-col>
      <el-col :span="12">0301</el-col><el-col :span="12">法学</el-col>
      <el-col :span="12">030101</el-col><el-col :span="12">法学理论</el-col>
      <el-col :span="12">030102</el-col><el-col :span="12">法律史</el-col>
      <el-col :span="12">030103</el-col><el-col :span="12">宪法学与行政法学</el-col>
      <el-col :span="12">030104</el-col><el-col :span="12">刑法学</el-col>
      <el-col :span="12">030105</el-col><el-col :span="12">民商法学</el-col>
      <el-col :span="12">030106</el-col><el-col :span="12">诉讼法学</el-col>
      <el-col :span="12">030107</el-col><el-col :span="12">经济法学</el-col>
      <el-col :span="12">030108</el-col><el-col :span="12">环境与资源保护法学</el-col>
      <el-col :span="12">030109</el-col><el-col :span="12">国际法学</el-col>
      <el-col :span="12">030110</el-col><el-col :span="12">军事法学</el-col>
      <el-col :span="12">0302</el-col><el-col :span="12">政治学</el-col>
      <el-col :span="12">030201</el-col><el-col :span="12">政治学理论</el-col>
      <el-col :span="12">030202</el-col><el-col :span="12">中外政治制度</el-col>
      <el-col :span="12">030203</el-col><el-col :span="12">科学社会主义与国际共产主义运动</el-col>
      <el-col :span="12">030204</el-col><el-col :span="12">中共党史</el-col>
      <el-col :span="12">030206</el-col><el-col :span="12">国际政治</el-col>
      <el-col :span="12">030207</el-col><el-col :span="12">国际关系</el-col>
      <el-col :span="12">030208</el-col><el-col :span="12">外交学</el-col>
      <el-col :span="12">0303</el-col><el-col :span="12">社会学</el-col>
      <el-col :span="12">030301</el-col><el-col :span="12">社会学</el-col>
      <el-col :span="12">030302</el-col><el-col :span="12">人口学</el-col>
      <el-col :span="12">030303</el-col><el-col :span="12">人类学</el-col>
      <el-col :span="12">030304</el-col><el-col :span="12">民俗学</el-col>
      <el-col :span="12">0304</el-col><el-col :span="12">民族学</el-col>
      <el-col :span="12">030401</el-col><el-col :span="12">民族学</el-col>
      <el-col :span="12">030402</el-col><el-col :span="12">马克思主义民族理论与政策</el-col>
      <el-col :span="12">030403</el-col><el-col :span="12">中国少数民族经济</el-col>
      <el-col :span="12">030404</el-col><el-col :span="12">中国少数民族史</el-col>
      <el-col :span="12">030405</el-col><el-col :span="12">中国少数民族艺术</el-col>
      <el-col :span="12">0305</el-col><el-col :span="12">马克思主义理论</el-col>
      <el-col :span="12">030501</el-col><el-col :span="12">马克思主义基本原理</el-col>
      <el-col :span="12">030502</el-col><el-col :span="12">马克思主义发展史</el-col>
      <el-col :span="12">030503</el-col><el-col :span="12">马克思主义中国化研究</el-col>
      <el-col :span="12">030504</el-col><el-col :span="12">国外马克思主义研究</el-col>
      <el-col :span="12">030505</el-col><el-col :span="12">思想政治教育</el-col>
      <el-col :span="12">030506</el-col><el-col :span="12">中国近现代史基本问题研究</el-col>
      <el-col :span="12">0306</el-col><el-col :span="12">公安学</el-col>
      <el-col :span="12">0307</el-col><el-col :span="12">中共党史党建学</el-col>
      <el-col :span="12">0308</el-col><el-col :span="12">纪检监察学</el-col>
      <el-col :span="12">0370</el-col><el-col :span="12">国家安全学</el-col>
      <el-col :span="12">0371</el-col><el-col :span="12">区域国别学</el-col>
      <el-col :span="12">0351</el-col><el-col :span="12">法律</el-col>
      <el-col :span="12">035101</el-col><el-col :span="12">法律(非法学)</el-col>
      <el-col :span="12">035102</el-col><el-col :span="12">法律(法学)</el-col>
      <el-col :span="12">0352</el-col><el-col :span="12">社会工作</el-col>
      <el-col :span="12">0353</el-col><el-col :span="12">警务</el-col>
      <el-col :span="12">0354</el-col><el-col :span="12">知识产权</el-col>
      <el-col :span="12">0355</el-col><el-col :span="12">国际事务</el-col>
      <el-col :span="12" style="font-weight: 700;">04</el-col>
      <el-col :span="12" style="font-weight: 700;">教育学</el-col>
      <el-col :span="12">0401</el-col><el-col :span="12">教育学</el-col>
      <el-col :span="12">040101</el-col><el-col :span="12">教育学原理</el-col>
      <el-col :span="12">040102</el-col><el-col :span="12">课程与教学论</el-col>
      <el-col :span="12">040103</el-col><el-col :span="12">教育史</el-col>
      <el-col :span="12">040104</el-col><el-col :span="12">比较教育学</el-col>
      <el-col :span="12">040105</el-col><el-col :span="12">学前教育学</el-col>
      <el-col :span="12">040106</el-col><el-col :span="12">高等教育学</el-col>
      <el-col :span="12">040107</el-col><el-col :span="12">成人教育学</el-col>
      <el-col :span="12">040108</el-col><el-col :span="12">职业技术教育学</el-col>
      <el-col :span="12">040109</el-col><el-col :span="12">特殊教育学</el-col>
      <el-col :span="12">040110</el-col><el-col :span="12">教育技术学</el-col>
      <el-col :span="12">040111</el-col><el-col :span="12">教育法学</el-col>
      <el-col :span="12">0402</el-col><el-col :span="12">心理学</el-col>
      <el-col :span="12">040201</el-col><el-col :span="12">基础心理学</el-col>
      <el-col :span="12">040202</el-col><el-col :span="12">发展与教育心理学</el-col>
      <el-col :span="12">040203</el-col><el-col :span="12">应用心理学</el-col>
      <el-col :span="12">0403</el-col><el-col :span="12">体育学</el-col>
      <el-col :span="12">040301</el-col><el-col :span="12">体育人文社会学</el-col>
      <el-col :span="12">040302</el-col><el-col :span="12">运动人体科学</el-col>
      <el-col :span="12">040303</el-col><el-col :span="12">体育教育训练学</el-col>
      <el-col :span="12">040304</el-col><el-col :span="12">民族传统体育学</el-col>
      <el-col :span="12">047101</el-col><el-col :span="12">教育经济与管理</el-col>
      <el-col :span="12">0451</el-col><el-col :span="12">教育</el-col>
      <el-col :span="12">045101</el-col><el-col :span="12">教育管理</el-col>
      <el-col :span="12">045102</el-col><el-col :span="12">学科教学(思政)</el-col>
      <el-col :span="12">045103</el-col><el-col :span="12">学科教学(语文)</el-col>
      <el-col :span="12">045104</el-col><el-col :span="12">学科教学(数学)</el-col>
      <el-col :span="12">045105</el-col><el-col :span="12">学科教学(物理)</el-col>
      <el-col :span="12">045106</el-col><el-col :span="12">学科教学(化学)</el-col>
      <el-col :span="12">045107</el-col><el-col :span="12">学科教学(生物)</el-col>
      <el-col :span="12">045108</el-col><el-col :span="12">学科教学(英语)</el-col>
      <el-col :span="12">045109</el-col><el-col :span="12">学科教学(历史)</el-col>
      <el-col :span="12">045110</el-col><el-col :span="12">学科教学(地理)</el-col>
      <el-col :span="12">045111</el-col><el-col :span="12">学科教学(音乐)</el-col>
      <el-col :span="12">045112</el-col><el-col :span="12">学科教学(体育)</el-col>
      <el-col :span="12">045113</el-col><el-col :span="12">学科教学(美术)</el-col>
      <el-col :span="12">045114</el-col><el-col :span="12">现代教育技术</el-col>
      <el-col :span="12">045115</el-col><el-col :span="12">小学教育</el-col>
      <el-col :span="12">045116</el-col><el-col :span="12">心理健康教育</el-col>
      <el-col :span="12">045117</el-col><el-col :span="12">科学与技术教育</el-col>
      <el-col :span="12">045118</el-col><el-col :span="12">学前教育</el-col>
      <el-col :span="12">045119</el-col><el-col :span="12">特殊教育</el-col>
      <el-col :span="12">045120</el-col><el-col :span="12">职业技术教育</el-col>
      <el-col :span="12">045171</el-col><el-col :span="12">学校课程与教学</el-col>
      <el-col :span="12">045172</el-col><el-col :span="12">学生发展与教育</el-col>
      <el-col :span="12">045173</el-col><el-col :span="12">教育领导与管理</el-col>
      <el-col :span="12">045174</el-col><el-col :span="12">汉语国际教育</el-col>
      <el-col :span="12">0452</el-col><el-col :span="12">体育</el-col>
      <el-col :span="12">045201</el-col><el-col :span="12">体育教学</el-col>
      <el-col :span="12">045202</el-col><el-col :span="12">运动训练</el-col>
      <el-col :span="12">045203</el-col><el-col :span="12">竞赛组织</el-col>
      <el-col :span="12">045204</el-col><el-col :span="12">社会体育指导</el-col>
      <el-col :span="12">0453</el-col><el-col :span="12">国际中文教育</el-col>
      <el-col :span="12">0454</el-col><el-col :span="12">应用心理</el-col>
      <el-col :span="12" style="font-weight: 700;">05</el-col>
      <el-col :span="12" style="font-weight: 700;">文学</el-col>
      <el-col :span="12">0501</el-col><el-col :span="12">中国语言文学</el-col>
      <el-col :span="12">050101</el-col><el-col :span="12">文艺学</el-col>
      <el-col :span="12">050102</el-col><el-col :span="12">语言学及应用语言学</el-col>
      <el-col :span="12">050103</el-col><el-col :span="12">汉语言文字学</el-col>
      <el-col :span="12">050104</el-col><el-col :span="12">中国古典文献学</el-col>
      <el-col :span="12">050105</el-col><el-col :span="12">中国古代文学</el-col>
      <el-col :span="12">050106</el-col><el-col :span="12">中国现当代文学</el-col>
      <el-col :span="12">050107</el-col><el-col :span="12">中国少数民族语言文学</el-col>
      <el-col :span="12">050108</el-col><el-col :span="12">比较文学与世界文学</el-col>
      <el-col :span="12">0502</el-col><el-col :span="12">外国语言文学</el-col>
      <el-col :span="12">050201</el-col><el-col :span="12">英语语言文学</el-col>
      <el-col :span="12">050202</el-col><el-col :span="12">俄语语言文学</el-col>
      <el-col :span="12">050203</el-col><el-col :span="12">法语语言文学</el-col>
      <el-col :span="12">050204</el-col><el-col :span="12">德语语言文学</el-col>
      <el-col :span="12">050205</el-col><el-col :span="12">日语语言文学</el-col>
      <el-col :span="12">050206</el-col><el-col :span="12">印度语言文学</el-col>
      <el-col :span="12">050207</el-col><el-col :span="12">西班牙语语言文学</el-col>
      <el-col :span="12">050208</el-col><el-col :span="12">阿拉伯语语言文学</el-col>
      <el-col :span="12">050209</el-col><el-col :span="12">欧洲语言文学</el-col>
      <el-col :span="12">050210</el-col><el-col :span="12">亚非语言文学</el-col>
      <el-col :span="12">050211</el-col><el-col :span="12">外国语言学及应用语言学</el-col>
      <el-col :span="12">0503</el-col><el-col :span="12">新闻传播学</el-col>
      <el-col :span="12">050301</el-col><el-col :span="12">新闻学</el-col>
      <el-col :span="12">050302</el-col><el-col :span="12">传播学</el-col>
      <el-col :span="12">0570</el-col><el-col :span="12">区域国别学</el-col>
      <el-col :span="12">0551</el-col><el-col :span="12">翻译</el-col>
      <el-col :span="12">055101</el-col><el-col :span="12">英语笔译</el-col>
      <el-col :span="12">055102</el-col><el-col :span="12">英语口译</el-col>
      <el-col :span="12">055103</el-col><el-col :span="12">俄语笔译</el-col>
      <el-col :span="12">055104</el-col><el-col :span="12">俄语口译</el-col>
      <el-col :span="12">055105</el-col><el-col :span="12">日语笔译</el-col>
      <el-col :span="12">055106</el-col><el-col :span="12">日语口译</el-col>
      <el-col :span="12">055107</el-col><el-col :span="12">法语笔译</el-col>
      <el-col :span="12">055108</el-col><el-col :span="12">法语口译</el-col>
      <el-col :span="12">055109</el-col><el-col :span="12">德语笔译</el-col>
      <el-col :span="12">055110</el-col><el-col :span="12">德语口译</el-col>
      <el-col :span="12">055111</el-col><el-col :span="12">朝鲜语笔译</el-col>
      <el-col :span="12">055112</el-col><el-col :span="12">朝鲜语口译</el-col>
      <el-col :span="12">055113</el-col><el-col :span="12">西班牙语笔译</el-col>
      <el-col :span="12">055114</el-col><el-col :span="12">西班牙语口译</el-col>
      <el-col :span="12">055115</el-col><el-col :span="12">阿拉伯语笔译</el-col>
      <el-col :span="12">055116</el-col><el-col :span="12">阿拉伯语口译</el-col>
      <el-col :span="12">055117</el-col><el-col :span="12">泰语笔译</el-col>
      <el-col :span="12">055118</el-col><el-col :span="12">泰语口译</el-col>
      <el-col :span="12">055119</el-col><el-col :span="12">意大利语笔译</el-col>
      <el-col :span="12">055120</el-col><el-col :span="12">意大利语口译</el-col>
      <el-col :span="12">055121</el-col><el-col :span="12">越南语笔译</el-col>
      <el-col :span="12">055122</el-col><el-col :span="12">越南语口译</el-col>
      <el-col :span="12">0552</el-col><el-col :span="12">新闻与传播</el-col>
      <el-col :span="12">0553</el-col><el-col :span="12">出版</el-col>
      <el-col :span="12" style="font-weight: 700;">06</el-col>
      <el-col :span="12" style="font-weight: 700;">历史学</el-col>
      <el-col :span="12">0601</el-col><el-col :span="12">考古学</el-col>
      <el-col :span="12">0602</el-col><el-col :span="12">中国史</el-col>
      <el-col :span="12">0603</el-col><el-col :span="12">世界史</el-col>
      <el-col :span="12">0670</el-col><el-col :span="12">区域国别学</el-col>
      <el-col :span="12">0651</el-col><el-col :span="12">博物馆</el-col>
      <el-col :span="12" style="font-weight: 700;">07</el-col>
      <el-col :span="12" style="font-weight: 700;">理学</el-col>
      <el-col :span="12">0701</el-col><el-col :span="12">数学</el-col>
      <el-col :span="12">070101</el-col><el-col :span="12">基础数学</el-col>
      <el-col :span="12">070102</el-col><el-col :span="12">计算数学</el-col>
      <el-col :span="12">070103</el-col><el-col :span="12">概率论与数理统计</el-col>
      <el-col :span="12">070104</el-col><el-col :span="12">应用数学</el-col>
      <el-col :span="12">070105</el-col><el-col :span="12">运筹学与控制论</el-col>
      <el-col :span="12">0702</el-col><el-col :span="12">物理学</el-col>
      <el-col :span="12">070201</el-col><el-col :span="12">理论物理</el-col>
      <el-col :span="12">070202</el-col><el-col :span="12">粒子物理与原子核物理</el-col>
      <el-col :span="12">070203</el-col><el-col :span="12">原子与分子物理</el-col>
      <el-col :span="12">070204</el-col><el-col :span="12">等离子体物理</el-col>
      <el-col :span="12">070205</el-col><el-col :span="12">凝聚态物理</el-col>
      <el-col :span="12">070206</el-col><el-col :span="12">声学</el-col>
      <el-col :span="12">070207</el-col><el-col :span="12">光学</el-col>
      <el-col :span="12">070208</el-col><el-col :span="12">无线电物理</el-col>
      <el-col :span="12">0703</el-col><el-col :span="12">化学</el-col>
      <el-col :span="12">070301</el-col><el-col :span="12">无机化学</el-col>
      <el-col :span="12">070302</el-col><el-col :span="12">分析化学</el-col>
      <el-col :span="12">070303</el-col><el-col :span="12">有机化学</el-col>
      <el-col :span="12">070304</el-col><el-col :span="12">物理化学</el-col>
      <el-col :span="12">070305</el-col><el-col :span="12">高分子化学与物理</el-col>
      <el-col :span="12">0704</el-col><el-col :span="12">天文学</el-col>
      <el-col :span="12">070401</el-col><el-col :span="12">天体物理</el-col>
      <el-col :span="12">070402</el-col><el-col :span="12">天体测量与天体力学</el-col>
      <el-col :span="12">0705</el-col><el-col :span="12">地理学</el-col>
      <el-col :span="12">070501</el-col><el-col :span="12">自然地理学</el-col>
      <el-col :span="12">070502</el-col><el-col :span="12">人文地理学</el-col>
      <el-col :span="12">070503</el-col><el-col :span="12">地图学与地理信息系统</el-col>
      <el-col :span="12">0706</el-col><el-col :span="12">大气科学</el-col>
      <el-col :span="12">070601</el-col><el-col :span="12">气象学</el-col>
      <el-col :span="12">070602</el-col><el-col :span="12">大气物理学与大气环境</el-col>
      <el-col :span="12">0707</el-col><el-col :span="12">海洋科学</el-col>
      <el-col :span="12">070701</el-col><el-col :span="12">物理海洋学</el-col>
      <el-col :span="12">070702</el-col><el-col :span="12">海洋化学</el-col>
      <el-col :span="12">070703</el-col><el-col :span="12">海洋生物学</el-col>
      <el-col :span="12">070704</el-col><el-col :span="12">海洋地质</el-col>
      <el-col :span="12">0708</el-col><el-col :span="12">地球物理学</el-col>
      <el-col :span="12">070801</el-col><el-col :span="12">固体地球物理学</el-col>
      <el-col :span="12">070802</el-col><el-col :span="12">空间物理学</el-col>
      <el-col :span="12">0709</el-col><el-col :span="12">地质学</el-col>
      <el-col :span="12">070901</el-col><el-col :span="12">矿物学、岩石学、矿床学</el-col>
      <el-col :span="12">070902</el-col><el-col :span="12">地球化学</el-col>
      <el-col :span="12">070903</el-col><el-col :span="12">古生物学与地层学</el-col>
      <el-col :span="12">070904</el-col><el-col :span="12">构造地质学</el-col>
      <el-col :span="12">070905</el-col><el-col :span="12">第四纪地质学</el-col>
      <el-col :span="12">0710</el-col><el-col :span="12">生物学</el-col>
      <el-col :span="12">071001</el-col><el-col :span="12">植物学</el-col>
      <el-col :span="12">071002</el-col><el-col :span="12">动物学</el-col>
      <el-col :span="12">071003</el-col><el-col :span="12">生理学</el-col>
      <el-col :span="12">071004</el-col><el-col :span="12">水生生物学</el-col>
      <el-col :span="12">071005</el-col><el-col :span="12">微生物学</el-col>
      <el-col :span="12">071006</el-col><el-col :span="12">神经生物学</el-col>
      <el-col :span="12">071007</el-col><el-col :span="12">遗传学</el-col>
      <el-col :span="12">071008</el-col><el-col :span="12">发育生物学</el-col>
      <el-col :span="12">071009</el-col><el-col :span="12">细胞生物学</el-col>
      <el-col :span="12">071010</el-col><el-col :span="12">生物化学与分子生物学</el-col>
      <el-col :span="12">071011</el-col><el-col :span="12">生物物理学</el-col>
      <el-col :span="12">0711</el-col><el-col :span="12">系统科学</el-col>
      <el-col :span="12">071101</el-col><el-col :span="12">系统理论</el-col>
      <el-col :span="12">071102</el-col><el-col :span="12">系统分析与集成</el-col>
      <el-col :span="12">0712</el-col><el-col :span="12">科学技术史</el-col>
      <el-col :span="12">0713</el-col><el-col :span="12">生态学</el-col>
      <el-col :span="12">0714</el-col><el-col :span="12">统计学</el-col>
      <el-col :span="12">0770</el-col><el-col :span="12">集成电路科学与工程</el-col>
      <el-col :span="12">0771</el-col><el-col :span="12">心理学</el-col>
      <el-col :span="12">077101</el-col><el-col :span="12">基础心理学</el-col>
      <el-col :span="12">077102</el-col><el-col :span="12">发展与教育心理学</el-col>
      <el-col :span="12">077103</el-col><el-col :span="12">应用心理学</el-col>
      <el-col :span="12">0772</el-col><el-col :span="12">力学</el-col>
      <el-col :span="12">077201</el-col><el-col :span="12">一般力学与力学基础</el-col>
      <el-col :span="12">077202</el-col><el-col :span="12">固体力学</el-col>
      <el-col :span="12">077203</el-col><el-col :span="12">流体力学</el-col>
      <el-col :span="12">077204</el-col><el-col :span="12">工程力学</el-col>
      <el-col :span="12">0773</el-col><el-col :span="12">材料科学与工程</el-col>
      <el-col :span="12">077301</el-col><el-col :span="12">材料物理与化学</el-col>
      <el-col :span="12">077302</el-col><el-col :span="12">材料学</el-col>
      <el-col :span="12">077303</el-col><el-col :span="12">材料加工工程</el-col>
      <el-col :span="12">0774</el-col><el-col :span="12">电子科学与技术</el-col>
      <el-col :span="12">077401</el-col><el-col :span="12">物理电子学</el-col>
      <el-col :span="12">077402</el-col><el-col :span="12">电路与系统</el-col>
      <el-col :span="12">077403</el-col><el-col :span="12">微电子学与固体电子学</el-col>
      <el-col :span="12">077404</el-col><el-col :span="12">电磁场与微波技术</el-col>
      <el-col :span="12">0775</el-col><el-col :span="12">计算机科学与技术</el-col>
      <el-col :span="12">077501</el-col><el-col :span="12">计算机系统结构</el-col>
      <el-col :span="12">077502</el-col><el-col :span="12">计算机软件与理论</el-col>
      <el-col :span="12">077503</el-col><el-col :span="12">计算机应用技术</el-col>
      <el-col :span="12">0776</el-col><el-col :span="12">环境科学与工程</el-col>
      <el-col :span="12">077601</el-col><el-col :span="12">环境科学</el-col>
      <el-col :span="12">077602</el-col><el-col :span="12">环境工程</el-col>
      <el-col :span="12">0777</el-col><el-col :span="12">生物医学工程</el-col>
      <el-col :span="12">0778</el-col><el-col :span="12">基础医学</el-col>
      <el-col :span="12">077801</el-col><el-col :span="12">人体解剖与组织胚胎学</el-col>
      <el-col :span="12">077802</el-col><el-col :span="12">免疫学</el-col>
      <el-col :span="12">077803</el-col><el-col :span="12">病原生物学</el-col>
      <el-col :span="12">077804</el-col><el-col :span="12">病理学与病理生理学</el-col>
      <el-col :span="12">077805</el-col><el-col :span="12">法医学</el-col>
      <el-col :span="12">077806</el-col><el-col :span="12">放射医学</el-col>
      <el-col :span="12">0779</el-col><el-col :span="12">公共卫生与预防医学</el-col>
      <el-col :span="12">077901</el-col><el-col :span="12">流行病与卫生统计学</el-col>
      <el-col :span="12">077902</el-col><el-col :span="12">劳动卫生与环境卫生学</el-col>
      <el-col :span="12">077903</el-col><el-col :span="12">营养与食品卫生学</el-col>
      <el-col :span="12">077904</el-col><el-col :span="12">儿少卫生与妇幼保健学</el-col>
      <el-col :span="12">077905</el-col><el-col :span="12">卫生毒理学</el-col>
      <el-col :span="12">077906</el-col><el-col :span="12">军事预防医学</el-col>
      <el-col :span="12">0780</el-col><el-col :span="12">药学</el-col>
      <el-col :span="12">078001</el-col><el-col :span="12">药物化学</el-col>
      <el-col :span="12">078002</el-col><el-col :span="12">药剂学</el-col>
      <el-col :span="12">078003</el-col><el-col :span="12">生药学</el-col>
      <el-col :span="12">078004</el-col><el-col :span="12">药物分析学</el-col>
      <el-col :span="12">078005</el-col><el-col :span="12">微生物与生化药学</el-col>
      <el-col :span="12">078006</el-col><el-col :span="12">药理学</el-col>
      <el-col :span="12">0781</el-col><el-col :span="12">中药学</el-col>
      <el-col :span="12">0783</el-col><el-col :span="12">护理学</el-col>
      <el-col :span="12">078401</el-col><el-col :span="12">教育技术学</el-col>
      <el-col :span="12">078501</el-col><el-col :span="12">运动人体科学</el-col>
      <el-col :span="12">078601</el-col><el-col :span="12">农药学</el-col>
      <el-col :span="12">0787</el-col><el-col :span="12">遥感科学与技术</el-col>
      <el-col :span="12">0788</el-col><el-col :span="12">智能科学与技术</el-col>
      <el-col :span="12">0789</el-col><el-col :span="12">纳米科学与工程</el-col>
      <el-col :span="12">0751</el-col><el-col :span="12">气象</el-col>
      <el-col :span="12" style="font-weight: 700;">08</el-col>
      <el-col :span="12" style="font-weight: 700;">工学</el-col>
      <el-col :span="12">0801</el-col><el-col :span="12">力学</el-col>
      <el-col :span="12">080101</el-col><el-col :span="12">一般力学与力学基础</el-col>
      <el-col :span="12">080102</el-col><el-col :span="12">固体力学</el-col>
      <el-col :span="12">080103</el-col><el-col :span="12">流体力学</el-col>
      <el-col :span="12">080104</el-col><el-col :span="12">工程力学</el-col>
      <el-col :span="12">0802</el-col><el-col :span="12">机械工程</el-col>
      <el-col :span="12">080201</el-col><el-col :span="12">机械制造及其自动化</el-col>
      <el-col :span="12">080202</el-col><el-col :span="12">机械电子工程</el-col>
      <el-col :span="12">080203</el-col><el-col :span="12">机械设计及理论</el-col>
      <el-col :span="12">080204</el-col><el-col :span="12">车辆工程</el-col>
      <el-col :span="12">0803</el-col><el-col :span="12">光学工程</el-col>
      <el-col :span="12">0804</el-col><el-col :span="12">仪器科学与技术</el-col>
      <el-col :span="12">080401</el-col><el-col :span="12">精密仪器及机械</el-col>
      <el-col :span="12">080402</el-col><el-col :span="12">测试计量技术及仪器</el-col>
      <el-col :span="12">0805</el-col><el-col :span="12">材料科学与工程</el-col>
      <el-col :span="12">080501</el-col><el-col :span="12">材料物理与化学</el-col>
      <el-col :span="12">080502</el-col><el-col :span="12">材料学</el-col>
      <el-col :span="12">080503</el-col><el-col :span="12">材料加工工程</el-col>
      <el-col :span="12">0806</el-col><el-col :span="12">冶金工程</el-col>
      <el-col :span="12">080601</el-col><el-col :span="12">冶金物理化学</el-col>
      <el-col :span="12">080602</el-col><el-col :span="12">钢铁冶金</el-col>
      <el-col :span="12">080603</el-col><el-col :span="12">有色金属冶金</el-col>
      <el-col :span="12">0807</el-col><el-col :span="12">动力工程及工程热物理</el-col>
      <el-col :span="12">080701</el-col><el-col :span="12">工程热物理</el-col>
      <el-col :span="12">080702</el-col><el-col :span="12">热能工程</el-col>
      <el-col :span="12">080703</el-col><el-col :span="12">动力机械及工程</el-col>
      <el-col :span="12">080704</el-col><el-col :span="12">流体机械及工程</el-col>
      <el-col :span="12">080705</el-col><el-col :span="12">制冷及低温工程</el-col>
      <el-col :span="12">080706</el-col><el-col :span="12">化工过程机械</el-col>
      <el-col :span="12">0808</el-col><el-col :span="12">电气工程</el-col>
      <el-col :span="12">080801</el-col><el-col :span="12">电机与电器</el-col>
      <el-col :span="12">080802</el-col><el-col :span="12">电力系统及其自动化</el-col>
      <el-col :span="12">080803</el-col><el-col :span="12">高电压与绝缘技术</el-col>
      <el-col :span="12">080804</el-col><el-col :span="12">电力电子与电力传动</el-col>
      <el-col :span="12">080805</el-col><el-col :span="12">电工理论与新技术</el-col>
      <el-col :span="12">0809</el-col><el-col :span="12">电子科学与技术</el-col>
      <el-col :span="12">080901</el-col><el-col :span="12">物理电子学</el-col>
      <el-col :span="12">080902</el-col><el-col :span="12">电路与系统</el-col>
      <el-col :span="12">080903</el-col><el-col :span="12">微电子学与固体电子学</el-col>
      <el-col :span="12">080904</el-col><el-col :span="12">电磁场与微波技术</el-col>
      <el-col :span="12">0810</el-col><el-col :span="12">信息与通信工程</el-col>
      <el-col :span="12">081001</el-col><el-col :span="12">通信与信息系统</el-col>
      <el-col :span="12">081002</el-col><el-col :span="12">信号与信息处理</el-col>
      <el-col :span="12">0811</el-col><el-col :span="12">控制科学与工程</el-col>
      <el-col :span="12">081101</el-col><el-col :span="12">控制理论与控制工程</el-col>
      <el-col :span="12">081102</el-col><el-col :span="12">检测技术与自动化装置</el-col>
      <el-col :span="12">081103</el-col><el-col :span="12">系统工程</el-col>
      <el-col :span="12">081104</el-col><el-col :span="12">模式识别与智能系统</el-col>
      <el-col :span="12">081105</el-col><el-col :span="12">导航、制导与控制</el-col>
      <el-col :span="12">0812</el-col><el-col :span="12">计算机科学与技术</el-col>
      <el-col :span="12">081201</el-col><el-col :span="12">计算机系统结构</el-col>
      <el-col :span="12">081202</el-col><el-col :span="12">计算机软件与理论</el-col>
      <el-col :span="12">081203</el-col><el-col :span="12">计算机应用技术</el-col>
      <el-col :span="12">0813</el-col><el-col :span="12">建筑学</el-col>
      <el-col :span="12">081301</el-col><el-col :span="12">建筑历史与理论</el-col>
      <el-col :span="12">081302</el-col><el-col :span="12">建筑设计及其理论</el-col>
      <el-col :span="12">081304</el-col><el-col :span="12">建筑技术科学</el-col>
      <el-col :span="12">0814</el-col><el-col :span="12">土木工程</el-col>
      <el-col :span="12">081401</el-col><el-col :span="12">岩土工程</el-col>
      <el-col :span="12">081402</el-col><el-col :span="12">结构工程</el-col>
      <el-col :span="12">081403</el-col><el-col :span="12">市政工程</el-col>
      <el-col :span="12">081404</el-col><el-col :span="12">供热、供燃气、通风及空调工程</el-col>
      <el-col :span="12">081405</el-col><el-col :span="12">防灾减灾工程及防护工程</el-col>
      <el-col :span="12">081406</el-col><el-col :span="12">桥梁与隧道工程</el-col>
      <el-col :span="12">0815</el-col><el-col :span="12">水利工程</el-col>
      <el-col :span="12">081501</el-col><el-col :span="12">水文学及水资源</el-col>
      <el-col :span="12">081502</el-col><el-col :span="12">水力学及河流动力学</el-col>
      <el-col :span="12">081503</el-col><el-col :span="12">水工结构工程</el-col>
      <el-col :span="12">081504</el-col><el-col :span="12">水利水电工程</el-col>
      <el-col :span="12">081505</el-col><el-col :span="12">港口、海岸及近海工程</el-col>
      <el-col :span="12">0816</el-col><el-col :span="12">测绘科学与技术</el-col>
      <el-col :span="12">081601</el-col><el-col :span="12">大地测量学与测量工程</el-col>
      <el-col :span="12">081602</el-col><el-col :span="12">摄影测量与遥感</el-col>
      <el-col :span="12">081603</el-col><el-col :span="12">地图制图学与地理信息工程</el-col>
      <el-col :span="12">0817</el-col><el-col :span="12">化学工程与技术</el-col>
      <el-col :span="12">081701</el-col><el-col :span="12">化学工程</el-col>
      <el-col :span="12">081702</el-col><el-col :span="12">化学工艺</el-col>
      <el-col :span="12">081703</el-col><el-col :span="12">生物化工</el-col>
      <el-col :span="12">081704</el-col><el-col :span="12">应用化学</el-col>
      <el-col :span="12">081705</el-col><el-col :span="12">工业催化</el-col>
      <el-col :span="12">0818</el-col><el-col :span="12">地质资源与地质工程</el-col>
      <el-col :span="12">081801</el-col><el-col :span="12">矿产普查与勘探</el-col>
      <el-col :span="12">081802</el-col><el-col :span="12">地球探测与信息技术</el-col>
      <el-col :span="12">081803</el-col><el-col :span="12">地质工程</el-col>
      <el-col :span="12">0819</el-col><el-col :span="12">矿业工程</el-col>
      <el-col :span="12">081901</el-col><el-col :span="12">采矿工程</el-col>
      <el-col :span="12">081902</el-col><el-col :span="12">矿物加工工程</el-col>
      <el-col :span="12">081903</el-col><el-col :span="12">安全技术及工程</el-col>
      <el-col :span="12">0820</el-col><el-col :span="12">石油与天然气工程</el-col>
      <el-col :span="12">082001</el-col><el-col :span="12">油气井工程</el-col>
      <el-col :span="12">082002</el-col><el-col :span="12">油气田开发工程</el-col>
      <el-col :span="12">082003</el-col><el-col :span="12">油气储运工程</el-col>
      <el-col :span="12">0821</el-col><el-col :span="12">纺织科学与工程</el-col>
      <el-col :span="12">082101</el-col><el-col :span="12">纺织工程</el-col>
      <el-col :span="12">082102</el-col><el-col :span="12">纺织材料与纺织品设计</el-col>
      <el-col :span="12">082103</el-col><el-col :span="12">纺织化学与染整工程</el-col>
      <el-col :span="12">082104</el-col><el-col :span="12">服装设计与工程</el-col>
      <el-col :span="12">0822</el-col><el-col :span="12">轻工技术与工程</el-col>
      <el-col :span="12">082201</el-col><el-col :span="12">制浆造纸工程</el-col>
      <el-col :span="12">082202</el-col><el-col :span="12">制糖工程</el-col>
      <el-col :span="12">082203</el-col><el-col :span="12">发酵工程</el-col>
      <el-col :span="12">082204</el-col><el-col :span="12">皮革化学与工程</el-col>
      <el-col :span="12">0823</el-col><el-col :span="12">交通运输工程</el-col>
      <el-col :span="12">082301</el-col><el-col :span="12">道路与铁道工程</el-col>
      <el-col :span="12">082302</el-col><el-col :span="12">交通信息工程及控制</el-col>
      <el-col :span="12">082303</el-col><el-col :span="12">交通运输规划与管理</el-col>
      <el-col :span="12">082304</el-col><el-col :span="12">载运工具运用工程</el-col>
      <el-col :span="12">0824</el-col><el-col :span="12">船舶与海洋工程</el-col>
      <el-col :span="12">082401</el-col><el-col :span="12">船舶与海洋结构物设计制造</el-col>
      <el-col :span="12">082402</el-col><el-col :span="12">轮机工程</el-col>
      <el-col :span="12">082403</el-col><el-col :span="12">水声工程</el-col>
      <el-col :span="12">0825</el-col><el-col :span="12">航空宇航科学与技术</el-col>
      <el-col :span="12">082501</el-col><el-col :span="12">飞行器设计</el-col>
      <el-col :span="12">082502</el-col><el-col :span="12">航空宇航推进理论与工程</el-col>
      <el-col :span="12">082503</el-col><el-col :span="12">航空宇航制造工程</el-col>
      <el-col :span="12">082504</el-col><el-col :span="12">人机与环境工程</el-col>
      <el-col :span="12">0826</el-col><el-col :span="12">兵器科学与技术</el-col>
      <el-col :span="12">082601</el-col><el-col :span="12">武器系统与运用工程</el-col>
      <el-col :span="12">082602</el-col><el-col :span="12">兵器发射理论与技术</el-col>
      <el-col :span="12">082603</el-col><el-col :span="12">火炮、自动武器与弹药工程</el-col>
      <el-col :span="12">082604</el-col><el-col :span="12">军事化学与烟火技术</el-col>
      <el-col :span="12">0827</el-col><el-col :span="12">核科学与技术</el-col>
      <el-col :span="12">082701</el-col><el-col :span="12">核能科学与工程</el-col>
      <el-col :span="12">082702</el-col><el-col :span="12">核燃料循环与材料</el-col>
      <el-col :span="12">082703</el-col><el-col :span="12">核技术及应用</el-col>
      <el-col :span="12">082704</el-col><el-col :span="12">辐射防护及环境保护</el-col>
      <el-col :span="12">0828</el-col><el-col :span="12">农业工程</el-col>
      <el-col :span="12">082801</el-col><el-col :span="12">农业机械化工程</el-col>
      <el-col :span="12">082802</el-col><el-col :span="12">农业水土工程</el-col>
      <el-col :span="12">082803</el-col><el-col :span="12">农业生物环境与能源工程</el-col>
      <el-col :span="12">082804</el-col><el-col :span="12">农业电气化与自动化</el-col>
      <el-col :span="12">0829</el-col><el-col :span="12">林业工程</el-col>
      <el-col :span="12">082901</el-col><el-col :span="12">森林工程</el-col>
      <el-col :span="12">082902</el-col><el-col :span="12">木材科学与技术</el-col>
      <el-col :span="12">082903</el-col><el-col :span="12">林产化学加工工程</el-col>
      <el-col :span="12">0830</el-col><el-col :span="12">环境科学与工程</el-col>
      <el-col :span="12">083001</el-col><el-col :span="12">环境科学</el-col>
      <el-col :span="12">083002</el-col><el-col :span="12">环境工程</el-col>
      <el-col :span="12">0831</el-col><el-col :span="12">生物医学工程</el-col>
      <el-col :span="12">0832</el-col><el-col :span="12">食品科学与工程</el-col>
      <el-col :span="12">083201</el-col><el-col :span="12">食品科学</el-col>
      <el-col :span="12">083202</el-col><el-col :span="12">粮食、油脂及植物蛋白工程</el-col>
      <el-col :span="12">083203</el-col><el-col :span="12">农产品加工及贮藏工程</el-col>
      <el-col :span="12">083204</el-col><el-col :span="12">水产品加工及贮藏工程</el-col>
      <el-col :span="12">0833</el-col><el-col :span="12">城乡规划学</el-col>
      <el-col :span="12">0835</el-col><el-col :span="12">软件工程</el-col>
      <el-col :span="12">0836</el-col><el-col :span="12">生物工程</el-col>
      <el-col :span="12">0837</el-col><el-col :span="12">安全科学与工程</el-col>
      <el-col :span="12">0838</el-col><el-col :span="12">公安技术</el-col>
      <el-col :span="12">0839</el-col><el-col :span="12">网络空间安全</el-col>
      <el-col :span="12">0870</el-col><el-col :span="12">科学技术史</el-col>
      <el-col :span="12">0871</el-col><el-col :span="12">管理科学与工程</el-col>
      <el-col :span="12">0872</el-col><el-col :span="12">设计学</el-col>
      <el-col :span="12">0873</el-col><el-col :span="12">集成电路科学与工程</el-col>
      <el-col :span="12">0874</el-col><el-col :span="12">国家安全学</el-col>
      <el-col :span="12">0875</el-col><el-col :span="12">遥感科学与技术</el-col>
      <el-col :span="12">0876</el-col><el-col :span="12">智能科学与技术</el-col>
      <el-col :span="12">0877</el-col><el-col :span="12">纳米科学与工程</el-col>
      <el-col :span="12">0851</el-col><el-col :span="12">建筑</el-col>
      <el-col :span="12">0853</el-col><el-col :span="12">城乡规划</el-col>
      <el-col :span="12">0854</el-col><el-col :span="12">电子信息</el-col>
      <el-col :span="12">085401</el-col><el-col :span="12">新一代电子信息技术(含量子技术等)</el-col>
      <el-col :span="12">085402</el-col><el-col :span="12">通信工程(含宽带网络、移动通信等)</el-col>
      <el-col :span="12">085403</el-col><el-col :span="12">集成电路工程</el-col>
      <el-col :span="12">085404</el-col><el-col :span="12">计算机技术</el-col>
      <el-col :span="12">085405</el-col><el-col :span="12">软件工程</el-col>
      <el-col :span="12">085406</el-col><el-col :span="12">控制工程</el-col>
      <el-col :span="12">085407</el-col><el-col :span="12">仪器仪表工程</el-col>
      <el-col :span="12">085408</el-col><el-col :span="12">光电信息工程</el-col>
      <el-col :span="12">085409</el-col><el-col :span="12">生物医学工程</el-col>
      <el-col :span="12">085410</el-col><el-col :span="12">人工智能</el-col>
      <el-col :span="12">085411</el-col><el-col :span="12">大数据技术与工程</el-col>
      <el-col :span="12">085412</el-col><el-col :span="12">网络与信息安全</el-col>
      <el-col :span="12">0855</el-col><el-col :span="12">机械</el-col>
      <el-col :span="12">085501</el-col><el-col :span="12">机械工程</el-col>
      <el-col :span="12">085502</el-col><el-col :span="12">车辆工程</el-col>
      <el-col :span="12">085503</el-col><el-col :span="12">航空工程</el-col>
      <el-col :span="12">085504</el-col><el-col :span="12">航天工程</el-col>
      <el-col :span="12">085505</el-col><el-col :span="12">船舶工程</el-col>
      <el-col :span="12">085506</el-col><el-col :span="12">兵器工程</el-col>
      <el-col :span="12">085507</el-col><el-col :span="12">工业设计工程</el-col>
      <el-col :span="12">085508</el-col><el-col :span="12">农机装备工程</el-col>
      <el-col :span="12">085509</el-col><el-col :span="12">智能制造技术</el-col>
      <el-col :span="12">085510</el-col><el-col :span="12">机器人工程</el-col>
      <el-col :span="12">0856</el-col><el-col :span="12">材料与化工</el-col>
      <el-col :span="12">085601</el-col><el-col :span="12">材料工程</el-col>
      <el-col :span="12">085602</el-col><el-col :span="12">化学工程</el-col>
      <el-col :span="12">085603</el-col><el-col :span="12">冶金工程</el-col>
      <el-col :span="12">085604</el-col><el-col :span="12">纺织工程</el-col>
      <el-col :span="12">085605</el-col><el-col :span="12">林业工程</el-col>
      <el-col :span="12">085606</el-col><el-col :span="12">轻化工程(含皮革、纸张、织物加工等)</el-col>
      <el-col :span="12">0857</el-col><el-col :span="12">资源与环境</el-col>
      <el-col :span="12">085701</el-col><el-col :span="12">环境工程</el-col>
      <el-col :span="12">085702</el-col><el-col :span="12">安全工程</el-col>
      <el-col :span="12">085703</el-col><el-col :span="12">地质工程</el-col>
      <el-col :span="12">085704</el-col><el-col :span="12">测绘工程</el-col>
      <el-col :span="12">085705</el-col><el-col :span="12">矿业工程</el-col>
      <el-col :span="12">085706</el-col><el-col :span="12">石油与天然气工程</el-col>
      <el-col :span="12">0858</el-col><el-col :span="12">能源动力</el-col>
      <el-col :span="12">085801</el-col><el-col :span="12">电气工程</el-col>
      <el-col :span="12">085802</el-col><el-col :span="12">动力工程</el-col>
      <el-col :span="12">085803</el-col><el-col :span="12">核能工程</el-col>
      <el-col :span="12">085804</el-col><el-col :span="12">航空发动机工程</el-col>
      <el-col :span="12">085805</el-col><el-col :span="12">燃气轮机工程</el-col>
      <el-col :span="12">085806</el-col><el-col :span="12">航天动力工程</el-col>
      <el-col :span="12">085807</el-col><el-col :span="12">清洁能源技术</el-col>
      <el-col :span="12">085808</el-col><el-col :span="12">储能技术</el-col>
      <el-col :span="12">0859</el-col><el-col :span="12">土木水利</el-col>
      <el-col :span="12">085901</el-col><el-col :span="12">土木工程</el-col>
      <el-col :span="12">085902</el-col><el-col :span="12">水利工程</el-col>
      <el-col :span="12">085903</el-col><el-col :span="12">海洋工程</el-col>
      <el-col :span="12">085904</el-col><el-col :span="12">农田水土工程</el-col>
      <el-col :span="12">085905</el-col><el-col :span="12">市政工程(含给排水等)</el-col>
      <el-col :span="12">085906</el-col><el-col :span="12">人工环境工程(含供热、通风及空调等)</el-col>
      <el-col :span="12">0860</el-col><el-col :span="12">生物与医药</el-col>
      <el-col :span="12">086001</el-col><el-col :span="12">生物技术与工程</el-col>
      <el-col :span="12">086002</el-col><el-col :span="12">制药工程</el-col>
      <el-col :span="12">086003</el-col><el-col :span="12">食品工程</el-col>
      <el-col :span="12">086004</el-col><el-col :span="12">发酵工程</el-col>
      <el-col :span="12">0861</el-col><el-col :span="12">交通运输</el-col>
      <el-col :span="12">086101</el-col><el-col :span="12">轨道交通运输</el-col>
      <el-col :span="12">086102</el-col><el-col :span="12">道路交通运输</el-col>
      <el-col :span="12">086103</el-col><el-col :span="12">水路交通运输</el-col>
      <el-col :span="12">086104</el-col><el-col :span="12">航空交通运输</el-col>
      <el-col :span="12">086105</el-col><el-col :span="12">管道交通运输</el-col>
      <el-col :span="12">0862</el-col><el-col :span="12">风景园林</el-col>
      <el-col :span="12" style="font-weight: 700;">09</el-col>
      <el-col :span="12" style="font-weight: 700;">农学</el-col>
      <el-col :span="12">0901</el-col><el-col :span="12">作物学</el-col>
      <el-col :span="12">090101</el-col><el-col :span="12">作物栽培学与耕作学</el-col>
      <el-col :span="12">090102</el-col><el-col :span="12">作物遗传育种</el-col>
      <el-col :span="12">0902</el-col><el-col :span="12">园艺学</el-col>
      <el-col :span="12">090201</el-col><el-col :span="12">果树学</el-col>
      <el-col :span="12">090202</el-col><el-col :span="12">蔬菜学</el-col>
      <el-col :span="12">090203</el-col><el-col :span="12">茶学</el-col>
      <el-col :span="12">0903</el-col><el-col :span="12">农业资源与环境</el-col>
      <el-col :span="12">090301</el-col><el-col :span="12">土壤学</el-col>
      <el-col :span="12">090302</el-col><el-col :span="12">植物营养学</el-col>
      <el-col :span="12">0904</el-col><el-col :span="12">植物保护</el-col>
      <el-col :span="12">090401</el-col><el-col :span="12">植物病理学</el-col>
      <el-col :span="12">090402</el-col><el-col :span="12">农业昆虫与害虫防治</el-col>
      <el-col :span="12">090403</el-col><el-col :span="12">农药学</el-col>
      <el-col :span="12">0905</el-col><el-col :span="12">畜牧学</el-col>
      <el-col :span="12">090501</el-col><el-col :span="12">动物遗传育种与繁殖</el-col>
      <el-col :span="12">090502</el-col><el-col :span="12">动物营养与饲料科学</el-col>
      <el-col :span="12">090504</el-col><el-col :span="12">特种经济动物饲养</el-col>
      <el-col :span="12">0906</el-col><el-col :span="12">兽医学</el-col>
      <el-col :span="12">090601</el-col><el-col :span="12">基础兽医学</el-col>
      <el-col :span="12">090602</el-col><el-col :span="12">预防兽医学</el-col>
      <el-col :span="12">090603</el-col><el-col :span="12">临床兽医学</el-col>
      <el-col :span="12">0907</el-col><el-col :span="12">林学</el-col>
      <el-col :span="12">090701</el-col><el-col :span="12">林木遗传育种</el-col>
      <el-col :span="12">090702</el-col><el-col :span="12">森林培育</el-col>
      <el-col :span="12">090703</el-col><el-col :span="12">森林保护学</el-col>
      <el-col :span="12">090704</el-col><el-col :span="12">森林经理学</el-col>
      <el-col :span="12">090705</el-col><el-col :span="12">野生动植物保护与利用</el-col>
      <el-col :span="12">090706</el-col><el-col :span="12">园林植物与观赏园艺</el-col>
      <el-col :span="12">090707</el-col><el-col :span="12">水土保持与荒漠化防治</el-col>
      <el-col :span="12">0908</el-col><el-col :span="12">水产</el-col>
      <el-col :span="12">090801</el-col><el-col :span="12">水产养殖</el-col>
      <el-col :span="12">090802</el-col><el-col :span="12">捕捞学</el-col>
      <el-col :span="12">090803</el-col><el-col :span="12">渔业资源</el-col>
      <el-col :span="12">0909</el-col><el-col :span="12">草学</el-col>
      <el-col :span="12">0910</el-col><el-col :span="12">水土保持与荒漠化防治学</el-col>
      <el-col :span="12">0970</el-col><el-col :span="12">科学技术史</el-col>
      <el-col :span="12">0971</el-col><el-col :span="12">环境科学与工程</el-col>
      <el-col :span="12">097101</el-col><el-col :span="12">环境科学</el-col>
      <el-col :span="12">097102</el-col><el-col :span="12">环境工程</el-col>
      <el-col :span="12">0972</el-col><el-col :span="12">食品科学与工程</el-col>
      <el-col :span="12">097201</el-col><el-col :span="12">食品科学</el-col>
      <el-col :span="12">097202</el-col><el-col :span="12">粮食、油脂及植物蛋白工程</el-col>
      <el-col :span="12">097203</el-col><el-col :span="12">农产品加工及贮藏工程</el-col>
      <el-col :span="12">097204</el-col><el-col :span="12">水产品加工及贮藏工程</el-col>
      <el-col :span="12">0951</el-col><el-col :span="12">农业</el-col>
      <el-col :span="12">095131</el-col><el-col :span="12">农艺与种业</el-col>
      <el-col :span="12">095132</el-col><el-col :span="12">资源利用与植物保护</el-col>
      <el-col :span="12">095133</el-col><el-col :span="12">畜牧</el-col>
      <el-col :span="12">095134</el-col><el-col :span="12">渔业发展</el-col>
      <el-col :span="12">095135</el-col><el-col :span="12">食品加工与安全</el-col>
      <el-col :span="12">095136</el-col><el-col :span="12">农业工程与信息技术</el-col>
      <el-col :span="12">095137</el-col><el-col :span="12">农业管理</el-col>
      <el-col :span="12">095138</el-col><el-col :span="12">农村发展</el-col>
      <el-col :span="12">0952</el-col><el-col :span="12">兽医</el-col>
      <el-col :span="12">0954</el-col><el-col :span="12">林业</el-col>
      <el-col :span="12">0955</el-col><el-col :span="12">食品与营养</el-col>
      <el-col :span="12" style="font-weight: 700;">10</el-col>
      <el-col :span="12" style="font-weight: 700;">医学</el-col>
      <el-col :span="12">1001</el-col><el-col :span="12">基础医学</el-col>
      <el-col :span="12">100101</el-col><el-col :span="12">人体解剖与组织胚胎学</el-col>
      <el-col :span="12">100102</el-col><el-col :span="12">免疫学</el-col>
      <el-col :span="12">100103</el-col><el-col :span="12">病原生物学</el-col>
      <el-col :span="12">100104</el-col><el-col :span="12">病理学与病理生理学</el-col>
      <el-col :span="12">100105</el-col><el-col :span="12">法医学</el-col>
      <el-col :span="12">100106</el-col><el-col :span="12">放射医学</el-col>
      <el-col :span="12">1002</el-col><el-col :span="12">临床医学</el-col>
      <el-col :span="12">100201</el-col><el-col :span="12">内科学</el-col>
      <el-col :span="12">100202</el-col><el-col :span="12">儿科学</el-col>
      <el-col :span="12">100203</el-col><el-col :span="12">老年医学</el-col>
      <el-col :span="12">100204</el-col><el-col :span="12">神经病学</el-col>
      <el-col :span="12">100205</el-col><el-col :span="12">精神病与精神卫生学</el-col>
      <el-col :span="12">100206</el-col><el-col :span="12">皮肤病与性病学</el-col>
      <el-col :span="12">100207</el-col><el-col :span="12">影像医学与核医学</el-col>
      <el-col :span="12">100208</el-col><el-col :span="12">临床检验诊断学</el-col>
      <el-col :span="12">100210</el-col><el-col :span="12">外科学</el-col>
      <el-col :span="12">100211</el-col><el-col :span="12">妇产科学</el-col>
      <el-col :span="12">100212</el-col><el-col :span="12">眼科学</el-col>
      <el-col :span="12">100213</el-col><el-col :span="12">耳鼻咽喉科学</el-col>
      <el-col :span="12">100214</el-col><el-col :span="12">肿瘤学</el-col>
      <el-col :span="12">100215</el-col><el-col :span="12">康复医学与理疗学</el-col>
      <el-col :span="12">100216</el-col><el-col :span="12">运动医学</el-col>
      <el-col :span="12">100217</el-col><el-col :span="12">麻醉学</el-col>
      <el-col :span="12">100218</el-col><el-col :span="12">急诊医学</el-col>
      <el-col :span="12">1003</el-col><el-col :span="12">口腔医学</el-col>
      <el-col :span="12">100301</el-col><el-col :span="12">口腔基础医学</el-col>
      <el-col :span="12">100302</el-col><el-col :span="12">口腔临床医学</el-col>
      <el-col :span="12">1004</el-col><el-col :span="12">公共卫生与预防医学</el-col>
      <el-col :span="12">100401</el-col><el-col :span="12">流行病与卫生统计学</el-col>
      <el-col :span="12">100402</el-col><el-col :span="12">劳动卫生与环境卫生学</el-col>
      <el-col :span="12">100403</el-col><el-col :span="12">营养与食品卫生学</el-col>
      <el-col :span="12">100404</el-col><el-col :span="12">儿少卫生与妇幼保健学</el-col>
      <el-col :span="12">100405</el-col><el-col :span="12">卫生毒理学</el-col>
      <el-col :span="12">100406</el-col><el-col :span="12">军事预防医学</el-col>
      <el-col :span="12">1005</el-col><el-col :span="12">中医学</el-col>
      <el-col :span="12">100501</el-col><el-col :span="12">中医基础理论</el-col>
      <el-col :span="12">100502</el-col><el-col :span="12">中医临床基础</el-col>
      <el-col :span="12">100503</el-col><el-col :span="12">中医医史文献</el-col>
      <el-col :span="12">100504</el-col><el-col :span="12">方剂学</el-col>
      <el-col :span="12">100505</el-col><el-col :span="12">中医诊断学</el-col>
      <el-col :span="12">100506</el-col><el-col :span="12">中医内科学</el-col>
      <el-col :span="12">100507</el-col><el-col :span="12">中医外科学</el-col>
      <el-col :span="12">100508</el-col><el-col :span="12">中医骨伤科学</el-col>
      <el-col :span="12">100509</el-col><el-col :span="12">中医妇科学</el-col>
      <el-col :span="12">100510</el-col><el-col :span="12">中医儿科学</el-col>
      <el-col :span="12">100511</el-col><el-col :span="12">中医五官科学</el-col>
      <el-col :span="12">100512</el-col><el-col :span="12">针灸推拿学</el-col>
      <el-col :span="12">100513</el-col><el-col :span="12">民族医学(含： 藏医学、蒙医学等)</el-col>
      <el-col :span="12">1006</el-col><el-col :span="12">中西医结合</el-col>
      <el-col :span="12">100601</el-col><el-col :span="12">中西医结合基础</el-col>
      <el-col :span="12">100602</el-col><el-col :span="12">中西医结合临床</el-col>
      <el-col :span="12">1007</el-col><el-col :span="12">药学</el-col>
      <el-col :span="12">100701</el-col><el-col :span="12">药物化学</el-col>
      <el-col :span="12">100702</el-col><el-col :span="12">药剂学</el-col>
      <el-col :span="12">100703</el-col><el-col :span="12">生药学</el-col>
      <el-col :span="12">100704</el-col><el-col :span="12">药物分析学</el-col>
      <el-col :span="12">100705</el-col><el-col :span="12">微生物与生化药学</el-col>
      <el-col :span="12">100706</el-col><el-col :span="12">药理学</el-col>
      <el-col :span="12">1008</el-col><el-col :span="12">中药学</el-col>
      <el-col :span="12">1009</el-col><el-col :span="12">特种医学</el-col>
      <el-col :span="12">1011</el-col><el-col :span="12">护理学</el-col>
      <el-col :span="12">1012</el-col><el-col :span="12">法医学</el-col>
      <el-col :span="12">1071</el-col><el-col :span="12">科学技术史</el-col>
      <el-col :span="12">1072</el-col><el-col :span="12">生物医学工程</el-col>
      <el-col :span="12">107301</el-col><el-col :span="12">运动人体科学</el-col>
      <el-col :span="12">107401</el-col><el-col :span="12">社会医学与卫生事业管理</el-col>
      <el-col :span="12">1051</el-col><el-col :span="12">临床医学</el-col>
      <el-col :span="12">105101</el-col><el-col :span="12">内科学</el-col>
      <el-col :span="12">105102</el-col><el-col :span="12">儿科学</el-col>
      <el-col :span="12">105103</el-col><el-col :span="12">老年医学</el-col>
      <el-col :span="12">105104</el-col><el-col :span="12">神经病学</el-col>
      <el-col :span="12">105105</el-col><el-col :span="12">精神病与精神卫生学</el-col>
      <el-col :span="12">105106</el-col><el-col :span="12">皮肤病与性病学</el-col>
      <el-col :span="12">105107</el-col><el-col :span="12">急诊医学</el-col>
      <el-col :span="12">105108</el-col><el-col :span="12">重症医学</el-col>
      <el-col :span="12">105109</el-col><el-col :span="12">全科医学</el-col>
      <el-col :span="12">105110</el-col><el-col :span="12">康复医学与理疗学</el-col>
      <el-col :span="12">105111</el-col><el-col :span="12">外科学</el-col>
      <el-col :span="12">105112</el-col><el-col :span="12">儿外科学</el-col>
      <el-col :span="12">105113</el-col><el-col :span="12">骨科学</el-col>
      <el-col :span="12">105114</el-col><el-col :span="12">运动医学</el-col>
      <el-col :span="12">105115</el-col><el-col :span="12">妇产科学</el-col>
      <el-col :span="12">105116</el-col><el-col :span="12">眼科学</el-col>
      <el-col :span="12">105117</el-col><el-col :span="12">耳鼻咽喉科学</el-col>
      <el-col :span="12">105118</el-col><el-col :span="12">麻醉学</el-col>
      <el-col :span="12">105119</el-col><el-col :span="12">临床病理</el-col>
      <el-col :span="12">105120</el-col><el-col :span="12">临床检验诊断学</el-col>
      <el-col :span="12">105121</el-col><el-col :span="12">肿瘤学</el-col>
      <el-col :span="12">105122</el-col><el-col :span="12">放射肿瘤学</el-col>
      <el-col :span="12">105123</el-col><el-col :span="12">放射影像学</el-col>
      <el-col :span="12">105124</el-col><el-col :span="12">超声医学</el-col>
      <el-col :span="12">105125</el-col><el-col :span="12">核医学</el-col>
      <el-col :span="12">105126</el-col><el-col :span="12">医学遗传学</el-col>
      <el-col :span="12">1052</el-col><el-col :span="12">口腔医学</el-col>
      <el-col :span="12">1053</el-col><el-col :span="12">公共卫生</el-col>
      <el-col :span="12">1054</el-col><el-col :span="12">护理</el-col>
      <el-col :span="12">1055</el-col><el-col :span="12">药学</el-col>
      <el-col :span="12">1056</el-col><el-col :span="12">中药</el-col>
      <el-col :span="12">1057</el-col><el-col :span="12">中医</el-col>
      <el-col :span="12">105701</el-col><el-col :span="12">中医内科学</el-col>
      <el-col :span="12">105702</el-col><el-col :span="12">中医外科学</el-col>
      <el-col :span="12">105703</el-col><el-col :span="12">中医骨伤科学</el-col>
      <el-col :span="12">105704</el-col><el-col :span="12">中医妇科学</el-col>
      <el-col :span="12">105705</el-col><el-col :span="12">中医儿科学</el-col>
      <el-col :span="12">105706</el-col><el-col :span="12">中医五官科学</el-col>
      <el-col :span="12">105707</el-col><el-col :span="12">针灸推拿学</el-col>
      <el-col :span="12">105708</el-col><el-col :span="12">民族医学(含： 藏医学、蒙医学等)</el-col>
      <el-col :span="12">105709</el-col><el-col :span="12">中西医结合临床</el-col>
      <el-col :span="12">105710</el-col><el-col :span="12">全科医学(中医，不授博士学位)</el-col>
      <el-col :span="12">1058</el-col><el-col :span="12">医学技术</el-col>
      <el-col :span="12">1059</el-col><el-col :span="12">针灸</el-col>
      <el-col :span="12" style="font-weight: 700;">11</el-col>
      <el-col :span="12" style="font-weight: 700;">军事学</el-col>
      <el-col :span="12">1101</el-col><el-col :span="12">军事思想与军事历史</el-col>
      <el-col :span="12">1102</el-col><el-col :span="12">战略学</el-col>
      <el-col :span="12">1103</el-col><el-col :span="12">联合作战学</el-col>
      <el-col :span="12">1104</el-col><el-col :span="12">军兵种作战学</el-col>
      <el-col :span="12">1105</el-col><el-col :span="12">军队指挥学</el-col>
      <el-col :span="12">1106</el-col><el-col :span="12">军队政治工作学</el-col>
      <el-col :span="12">1107</el-col><el-col :span="12">军事后勤学</el-col>
      <el-col :span="12">1108</el-col><el-col :span="12">军事装备学</el-col>
      <el-col :span="12">1109</el-col><el-col :span="12">军事管理学</el-col>
      <el-col :span="12">1110</el-col><el-col :span="12">军事训练学</el-col>
      <el-col :span="12">1111</el-col><el-col :span="12">军事智能</el-col>
      <el-col :span="12">1170</el-col><el-col :span="12">国家安全学</el-col>
      <el-col :span="12">1152</el-col><el-col :span="12">联合作战指挥</el-col>
      <el-col :span="12">1153</el-col><el-col :span="12">军兵种作战指挥</el-col>
      <el-col :span="12">1154</el-col><el-col :span="12">作战指挥保障</el-col>
      <el-col :span="12">1155</el-col><el-col :span="12">战时政治工作</el-col>
      <el-col :span="12">1156</el-col><el-col :span="12">后勤与装备保障</el-col>
      <el-col :span="12">1157</el-col><el-col :span="12">军事训练与管理</el-col>
      <el-col :span="12" style="font-weight: 700;">12</el-col>
      <el-col :span="12" style="font-weight: 700;">管理学</el-col>
      <el-col :span="12">1201</el-col><el-col :span="12">管理科学与工程</el-col>
      <el-col :span="12">1202</el-col><el-col :span="12">工商管理学</el-col>
      <el-col :span="12">120201</el-col><el-col :span="12">会计学</el-col>
      <el-col :span="12">120202</el-col><el-col :span="12">企业管理</el-col>
      <el-col :span="12">120203</el-col><el-col :span="12">旅游管理</el-col>
      <el-col :span="12">120204</el-col><el-col :span="12">技术经济及管理</el-col>
      <el-col :span="12">1203</el-col><el-col :span="12">农林经济管理</el-col>
      <el-col :span="12">120301</el-col><el-col :span="12">农业经济管理</el-col>
      <el-col :span="12">120302</el-col><el-col :span="12">林业经济管理</el-col>
      <el-col :span="12">1204</el-col><el-col :span="12">公共管理学</el-col>
      <el-col :span="12">120401</el-col><el-col :span="12">行政管理</el-col>
      <el-col :span="12">120402</el-col><el-col :span="12">社会医学与卫生事业管理</el-col>
      <el-col :span="12">120403</el-col><el-col :span="12">教育经济与管理</el-col>
      <el-col :span="12">120404</el-col><el-col :span="12">社会保障</el-col>
      <el-col :span="12">120405</el-col><el-col :span="12">土地资源管理</el-col>
      <el-col :span="12">1205</el-col><el-col :span="12">信息资源管理</el-col>
      <el-col :span="12">120501</el-col><el-col :span="12">图书馆学</el-col>
      <el-col :span="12">120502</el-col><el-col :span="12">情报学</el-col>
      <el-col :span="12">120503</el-col><el-col :span="12">档案学</el-col>
      <el-col :span="12">1270</el-col><el-col :span="12">安全科学与工程</el-col>
      <el-col :span="12">1271</el-col><el-col :span="12">国家安全学</el-col>
      <el-col :span="12">1251</el-col><el-col :span="12">工商管理</el-col>
      <el-col :span="12">1252</el-col><el-col :span="12">公共管理</el-col>
      <el-col :span="12">1253</el-col><el-col :span="12">会计</el-col>
      <el-col :span="12">1254</el-col><el-col :span="12">旅游管理</el-col>
      <el-col :span="12">1255</el-col><el-col :span="12">图书情报</el-col>
      <el-col :span="12">1256</el-col><el-col :span="12">工程管理</el-col>
      <el-col :span="12">125601</el-col><el-col :span="12">工程管理</el-col>
      <el-col :span="12">125602</el-col><el-col :span="12">项目管理</el-col>
      <el-col :span="12">125603</el-col><el-col :span="12">工业工程与管理</el-col>
      <el-col :span="12">125604</el-col><el-col :span="12">物流工程与管理</el-col>
      <el-col :span="12">1257</el-col><el-col :span="12">审计</el-col>
      <el-col :span="12" style="font-weight: 700;">13</el-col>
      <el-col :span="12" style="font-weight: 700;">艺术学</el-col>
      <el-col :span="12">1301</el-col><el-col :span="12">艺术学</el-col>
      <el-col :span="12">1370</el-col><el-col :span="12">设计学</el-col>
      <el-col :span="12">1352</el-col><el-col :span="12">音乐</el-col>
      <el-col :span="12">1353</el-col><el-col :span="12">舞蹈</el-col>
      <el-col :span="12">1354</el-col><el-col :span="12">戏剧与影视</el-col>
      <el-col :span="12">1355</el-col><el-col :span="12">戏曲与曲艺</el-col>
      <el-col :span="12">1356</el-col><el-col :span="12">美术与书法</el-col>
      <el-col :span="12">1357</el-col><el-col :span="12">设计</el-col>
      <el-col :span="12" style="font-weight: 700;">14</el-col>
      <el-col :span="12" style="font-weight: 700;">交叉学科</el-col>
      <el-col :span="12">1401</el-col><el-col :span="12">集成电路科学与工程</el-col>
      <el-col :span="12">1402</el-col><el-col :span="12">国家安全学</el-col>
      <el-col :span="12">1403</el-col><el-col :span="12">设计学</el-col>
      <el-col :span="12">1404</el-col><el-col :span="12">遥感科学与技术</el-col>
      <el-col :span="12">1405</el-col><el-col :span="12">智能科学与技术</el-col>
      <el-col :span="12">1406</el-col><el-col :span="12">纳米科学与工程</el-col>
      <el-col :span="12">1407</el-col><el-col :span="12">区域国别学</el-col>
      <el-col :span="12">1451</el-col><el-col :span="12">文物</el-col>
      <el-col :span="12">1452</el-col><el-col :span="12">密码</el-col>
    </el-row>
  </div>
</template>

<script>
// 按需导入 API 接口
// import { getUserChannelAPI } from '@/api/homeAPI'

export default {
  name: 'Major',
  data() {
    return {
    }
  },
  created() {},
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.content-title {
  text-align: center;
  color: #303133;
  height: 60px;
}
p {
  margin-block-start: 0.05rem;
  margin-block-end: 0.05rem;
}
.science-press-p {
  font-size: 20px;
  text-indent: 0.3rem;
  text-align:justify;
  line-height: 1.6;
}
/deep/ .el-col-12 {
  font-size: 20px;
  text-align: center;
  padding: 5px;
  border-top: 1px solid #000;
}
</style>
